var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reaction-picker"},_vm._l((_vm.reactions),function(reaction){return _c('button',{key:reaction.class,staticClass:"reaction-picker__emoji",on:{"click":function($event){return _vm.$emit('clickReaction', reaction.type)}}},[_c('i',{staticClass:"twa",class:reaction.class})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }